export function Placeholder({ title, subtitle }: { title: string; subtitle?: string }) {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl mb-1">{title}</h1>
        {subtitle && <p className="text-ink-soft">{subtitle}</p>}
      </div>
      <div className="bg-white rounded border border-line p-8 text-center max-w-2xl">
        <p className="text-ink-soft text-sm">Coming soon.</p>
      </div>
    </div>
  )
}